import httpManager from "@/app/shared/utils/httpManager";
export default async function (params) {
  let query = "";
  query += params.entity ? `entity=${params.entity}&` : "";
  query += params.campaign ? `portfolio=${params.campaign}&` : "";
  query += params.base ? `base=${params.base}&` : "";
  if (params.startValue.length < 17)
    query += params.startValue ? `start_date=${params.startValue + " " + "00:00:00"}&` : "";
  else query += params.startValue ? `start_date=${params.startValue}&` : "";
  if (params.endValue.length < 17)
    query += params.endValue ? `end_date=${params.endValue + " " + "23:59:00"}&` : "";
  else
    query += params.endValue ? `end_date=${params.endValue}&` : "";
  query += params.user ? `user=${params.user}` : "";

  const url = `/reports/${params.type}/download/?${query}`;
  const response = await httpManager.post(url, {}, { blob: true });
  return response;
}
